// Une vente e-commerce est une vente dont la source est renseignée (« prestashop » aujourd'hui).
// Le critère est « source non vide », et non le nom d'une boutique : c'est celui qu'applique
// storehouse, et un second connecteur ne doit pas rouvrir les actions manuelles par oubli.
export function isEcomSale(transfer) {
    return !!transfer && typeof transfer.source === 'string' && transfer.source.trim() !== '';
}

// Adresse d'une commande dans l'administration de la boutique, si elle est sûre à mettre dans
// un href : seules les URL absolues http(s) sont rendues, tout le reste (javascript:, data:,
// adresse relative ou illisible) donne une chaîne vide. À n'utiliser que dans un href.
export function safeEcomOrderUrl(value) {
    if (typeof value !== 'string' || !value.trim()) return '';
    try {
        const url = new URL(value.trim());
        return url.protocol === 'http:' || url.protocol === 'https:' ? url.href : '';
    } catch (e) {
        return '';
    }
}
